import { inject, Injectable } from '@angular/core';
import { SENTRY_ERROR_LOGGER } from '@improver/infrastructure/sentry-data-layer';
import { SentryErrorHandler } from '@sentry/angular-ivy';

const IGNORED_STATUS = [401, 400, 403, 0];

@Injectable()
export class GlobalErrorHandler {
  private readonly sentryErrorHandler: SentryErrorHandler = inject(SENTRY_ERROR_LOGGER);
  private readonly chunkLoadErrorPatterns = [
    /Loading chunk [\d]+ failed/i,
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
  ];

  handleError(error: any) {
    if (this.chunkLoadErrorPatterns.some((pattern) => pattern.test(error.message))) {
      this.reloadPage();

      return;
    }

    if (IGNORED_STATUS.some((item) => item === error.status)) {
      return;
    }

    this.sentryErrorHandler.handleError(error);
  }

  private reloadPage() {
    window.location.reload();
  }
}
